import { officeAnalyticsConstants } from "../actions/constants";

const initState = {
    loading: false,
    error: null,
    office: null,
    analytics: {
        summary: {
            day: null,
            week: null,
            month: null,
        },
        day: [],
        week: [],
        month: [],
    },
    calendar: null,
    monthKey: "",
    range: null,
};

export default (state = initState, action) => {
    switch (action.type) {
        case officeAnalyticsConstants.GET_OFFICE_ANALYTICS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case officeAnalyticsConstants.GET_OFFICE_ANALYTICS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                office: action.payload?.office || null,
                analytics: action.payload?.analytics || initState.analytics,
                calendar: action.payload?.calendar || null,
                monthKey: action.payload?.monthKey || action.payload?.calendar?.monthKey || "",
                range: action.payload?.range || null,
            };

        case officeAnalyticsConstants.GET_OFFICE_ANALYTICS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload?.error || "Ошибка загрузки аналитики",
            };

        case officeAnalyticsConstants.CLEAR_OFFICE_ANALYTICS:
            return {
                ...initState,
            };

        default:
            return state;
    }
};
